<template>
    <div class="row">
        <router-link :to="{ name: 'penyewaan.alat-berat.edit', params: { id: data.id } }" class="col-12 col-md-4" v-for="data in datas" v-bind:key="data">
            <div class="card card-body shadow mb-3">
                <h4>{{ data.kode }} | {{ data.nama }}</h4>
                <h5 class="small mb-1">Jumlah : {{ data.jumlah }}</h5>
                <h5 class="small mb-1">Disewakan : {{ data.disewakan }}</h5>
            </div>
        </router-link>
    </div>
    <owl-floating-button to="penyewaan-master-alat-berat-create">
        <font-awesome-icon icon="plus"></font-awesome-icon>
</owl-floating-button>
</template>

<script>
import OwlFloatingButton from "@/components/OwlFloatingButton.vue";

export default {
    name: "IndexWeb",
    components: { OwlFloatingButton },
    data() {
        return {
            datas: {},
        }
    },
    mounted() {
        this.axios.get('alat_berat-list').then((response) => {
            this.datas = response.data;
        });
    }
};
</script>